<!--
    描述： 造价文件模块 ---xml 预览
    时间： 2020/5/22
    created by zjj
-->
<template>
    <div class="preview-layout">
        <el-row :gutter="15">
            <el-col :span="12">
                <el-tooltip placement="top-start">
                    <div slot="content">
                        {{ fileName }}
                    </div>
                    <div class="preview-header">{{ fileName }}</div>
                </el-tooltip>
                <el-table
                    height="500"
                    class="w100 h100"
                    highlight-current-row
                    :data="leftData"
                    v-loading="loading"
                    border
                    stripe
                    @row-click="rowClick"
                >
                    <el-table-column
                        label="序号"
                        type="index"
                        align="center"
                        show-overflow-tooltip
                        width="50"
                    >
                    </el-table-column>
                    <el-table-column
                        label="单位文件名称"
                        prop="name"
                        header-align="center"
                        align="left"
                        show-overflow-tooltip
                        min-width="120"
                    >
                    </el-table-column>
                    <el-table-column
                        label="匹配单位工程"
                        prop="name"
                        align="center"
                        show-overflow-tooltip
                        min-width="120"
                    >
                        <template slot-scope="scope">
                            <el-select
                                v-model="scope.row.danWeiId"
                                @change="onChange($event, scope.row)"
                                clearable
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="(item, index) in curUnitList"
                                    :key="'单位工程' + index"
                                    :label="item.name"
                                    :value="item.id"
                                    :disabled="item.disabled"
                                >
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="是否有数据"
                        prop="isData"
                        align="center"
                        width="95"
                    >
                        <template slot-scope="scope">
                            <div>
                                <template v-if="scope.row.isData === '是'">
                                    <el-popover
                                        trigger="hover"
                                        content="原有数据将被覆盖！"
                                        placement="top-start"
                                    >
                                        <i slot="reference" class="el-icon-warning"></i>
                                    </el-popover>
                                </template>
                                {{ scope.row.isData }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="6">
                <el-tooltip placement="top-start">
                    <div slot="content">
                        {{ "拟导入单位工程: " + rowName }}
                    </div>
                    <div class="preview-header text-overflow">
                        {{ "拟导入单位工程: " + rowName }}
                    </div>
                </el-tooltip>
                
                <el-table
                    height="500"
                    class="w100 h100"
                    highlight-current-row
                    :data="oldData"
                    v-loading="loading"
                    border
                    stripe
                >
                    <el-table-column
                        label="序号"
                        type="index"
                        align="center"
                        width="55"
                    ></el-table-column>
                    <el-table-column
                        label="费用名称"
                        prop="name"
                        header-align="center"
                        align="left"
                        show-overflow-tooltip
                        min-width="90"
                    ></el-table-column>
                    <el-table-column
                        label="金额(元)"
                        prop="total"
                        header-align="center"
                        align="right"
                        show-overflow-tooltip
                        width="100"
                    ></el-table-column>
                </el-table>
            </el-col>
            <el-col :span="6">
                <el-tooltip placement="bottom-start">
                    <div slot="content">
                        {{ "匹配项目结构单位工程：" + unitName }}
                    </div>
                    <div class="preview-header text-overflow btn-header">
                        {{ "匹配项目结构单位工程：" + unitName }}
                        <el-popover
                            placement="top-start"
                            title="自动匹配: "
                            width="350"
                            trigger="hover"
                            content="按照拟导入造价XML文件的单位工程名称，与项目结构的单位工程名称完全一致进行匹配。匹配错误或未能匹配的单位工程，用户可以手工调整。"
                        >
                            <el-button
                                slot="reference"
                                size="mini"
                                class="fr"
                                type="primary"
                                @click="autoMatchUnit"
                                >自动匹配</el-button
                            >
                        </el-popover>
                    </div>
                </el-tooltip>
                
                <el-table
                    height="500"
                    class="w100 h100"
                    highlight-current-row
                    :data="newData"
                    v-loading="loading"
                    border
                    stripe
                >
                    <el-table-column
                        label="序号"
                        type="index"
                        align="center"
                        width="55"
                    ></el-table-column>
                    <el-table-column
                        label="费用名称"
                        prop="costName"
                        header-align="center"
                        align="left"
                        show-overflow-tooltip
                        min-width="90"
                    ></el-table-column>
                    <el-table-column
                        label="金额(元)"
                        prop="costValue"
                        header-align="center"
                        align="right"
                        show-overflow-tooltip
                        width="100"
                    ></el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { judgeDanweiIsData, matchUnit, matchVisaUnit } from "@/api/modules/project_costfiles";
import { judgeAuditIsData, autoMatchTracking } from "@/api/modules/trackAudit";
export default {
    name: "xml-preview",
    props: {
        // xml 表格数据
        tableData: {
            type: Array,
            default: () => {
                return [];
            },
        },
        fileName: {
            //名称
            type: String,
            default: "",
        },
        unitList: {
            //工程列表
            type: Array,
            default: () => {
                return [];
            },
        },
        phase: {
            //造价码表
            type: String,
            default: "",
        },
        // 来自签证
        fromVisa: {
            type: Boolean,
            default: false
        },
        // 跟踪审计的（第几期）
        period: {
            type: Number,
            default: 0,
        },
        // 跟踪审计的 所选类型（0 申报， 1审批）
        costType: {
            type: String,
            default: "0",
        },
    },
    data() {
        return {
            leftData: [],
            loading: false,
            oldData: [], // xml 文件详细数据
            newData: [], // 所选项目结构 文件详细数据
            selectedData: [], // 已经选择的单位工程id
            rowName: "", // 当前行的单位文件名称
            unitName: "", // 当前选择的 单位工程名称
        };
    },
    created() {
        this.leftData = this.tableData;
    },
    methods: {
        // 左侧单行点击事件
        rowClick(row) {
            this.unitName = "";
            if (row.summaryItem.length > 0) {
                this.oldData = row.summaryItem;
                this.rowName = row.name;

                // 判断是否选择了 匹配单位
                if (row.danWeiId) {
                    this.unitName = this.curUnitList.find(
                        (x) => x.id === row.danWeiId
                    ).name;
                    this.onChange(row.danWeiId, row, "view");
                } else {
                    this.newData = [];
                }
            }
        },

        // 单项工程下拉框切换事件
        onChange(val, row, type) {
            // 获取当前的 结构数据
            if (val !== "") {
                this.unitName = this.curUnitList.find((x) => x.id === row.danWeiId).name;

                //判断从跟踪审计页面进来
                if (this.period !== 0) {
                    judgeAuditIsData({
                        danWeiId: val,
                        periods: this.period,
                        type: this.costType,
                    }).then((res) => {
                        if (res.code === 0 && res.data.length > 0) {
                            // 如果是行点击触发
                            if (type) {
                                setTimeout(() => {
                                    row.isData = "是";
                                    row.danWeiId = val;
                                    let index = this.leftData.findIndex((item) => {
                                        return item.id == row.id;
                                    });
                                    this.$set(this.leftData, index, row);
                                    this.newData = res.data;
                                }, 300);
                            } else {
                                this.$confirm("当前单位工程下有数据，是否覆盖?", "警告", {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    type: "warning",
                                })
                                    .then(() => {
                                        setTimeout(() => {
                                            row.isData = "是";
                                            row.danWeiId = val;
                                            let index = this.leftData.findIndex(
                                                (item) => {
                                                    return item.id == row.id;
                                                }
                                            );
                                            this.$set(this.leftData, index, row);
                                            this.newData = res.data;
                                        }, 300);
                                    })
                                    .catch(() => {
                                        row.danWeiId = "";
                                        this.onChange("", row);
                                    });
                            }
                        } else {
                            setTimeout(() => {
                                row.isData = "否";
                                let index = this.leftData.findIndex((item) => {
                                    return item.id == row.id;
                                });
                                this.$set(this.leftData, index, row);
                                this.newData = [];
                            }, 300);
                        }
                    });
                } else {
                    if (this.phase === "") {
                        return;
                    }

                    judgeDanweiIsData({
                        danWeiId: val,
                        phase: this.phase,
                    }).then((res) => {
                        if (res.code === 0 && res.data.length > 0) {
                            // 如果是行点击触发
                            if (type) {
                                setTimeout(() => {
                                    row.isData = "是";
                                    row.danWeiId = val;
                                    let index = this.leftData.findIndex((item) => {
                                        return item.id == row.id;
                                    });
                                    this.$set(this.leftData, index, row);
                                    this.newData = res.data;
                                }, 300);
                            } else {
                                this.$confirm("当前单位工程下有数据，是否覆盖?", "警告", {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    type: "warning",
                                })
                                    .then(() => {
                                        setTimeout(() => {
                                            row.isData = "是";
                                            row.danWeiId = val;
                                            let index = this.leftData.findIndex(
                                                (item) => {
                                                    return item.id == row.id;
                                                }
                                            );
                                            this.$set(this.leftData, index, row);
                                            this.newData = res.data;
                                        }, 300);
                                    })
                                    .catch(() => {
                                        row.danWeiId = "";
                                        this.onChange("", row);
                                    });
                            }
                        } else {
                            setTimeout(() => {
                                row.isData = "否";
                                let index = this.leftData.findIndex((item) => {
                                    return item.id == row.id;
                                });
                                this.$set(this.leftData, index, row);
                                this.newData = [];
                            }, 300);
                        }
                    });
                }
            } else {
                this.unitName = "";
                row.isData = "";
                this.newData = [];
            }
        },

        // 匹配单位工程
        autoMatchUnit() {
            this.loading = true;
            // 跟踪审计页面
            if (this.period !== 0) {
                let params = {
                    param1: this.leftData,
                    numberPeriods: this.period,
                    projectId: this.curProjectId,
                    type: this.costType,    // 0： 申报进度款、1：审批进度款
                };
                autoMatchTracking(params)
                    .then((res) => {
                        // console.log(res)

                        // 全部拟导入的xml 文件数据长度
                        let _allLength = res.data.param1.length;
                        // 有数据的 单位工程 长度
                        let _existLength = res.data.danWeiNames.length;
                        // 匹配失败的 单位工程长度
                        let _failedLength = res.data.param1.filter((x) => x.danWeiId === "")
                            .length;
                        // 匹配成功的 单位工程长度
                        let _successLength = _allLength - _failedLength;

                        // 提示消息
                        let _msg = `拟导入的XML文件共 ${_allLength} 个单位工程，${_successLength} 个单位工程匹配成功；其中 ${_existLength} 个节点已有数据；${_failedLength} 个单位工程匹配失败，请手动处理。`;

                        this.$message({
                            showClose: true,
                            message: _msg,
                            type: "warning",
                            duration: 5000,
                        });

                        this.loading = false;
                        this.$set(this, "leftData", res.data.param1);
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            } else if (this.fromVisa) {
                let params = {
                    param1: this.leftData,
                    phase: this.phase,
                    projectId: this.curProjectId,
                };
                matchVisaUnit(params)
                    .then((res) => {
                        // console.log(res)
                        // 全部拟导入的xml 文件数据长度
                        let _allLength = res.data.param1.length;
                        // 有数据的 单位工程 长度
                        let _existLength = res.data.danWeiNames.length;
                        // 匹配失败的 单位工程长度
                        let _failedLength = res.data.param1.filter(
                            (x) => x.danWeiId === ""
                        ).length;
                        // 匹配成功的 单位工程长度
                        let _successLength = _allLength - _failedLength;

                        // 提示消息
                        let _msg = `拟导入的XML文件共 ${_allLength} 个单位工程，${_successLength} 个单位工程匹配成功；其中 ${_existLength} 个节点已有数据；${_failedLength} 个单位工程匹配失败，请手动处理。`;

                        this.$message({
                            showClose: true,
                            message: _msg,
                            type: "warning",
                            duration: 5000,
                        });

                        this.loading = false;
                        this.$set(this, "leftData", res.data.param1);
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            } else {
                let params = {
                    param1: this.leftData,
                    phase: this.phase,
                    projectId: this.curProjectId,
                };
                matchUnit(params)
                    .then((res) => {
                        // console.log(res)

                        // 全部拟导入的xml 文件数据长度
                        let _allLength = res.data.param1.length;
                        // 有数据的 单位工程 长度
                        let _existLength = res.data.danWeiNames.length;
                        // 匹配失败的 单位工程长度
                        let _failedLength = res.data.param1.filter(
                            (x) => x.danWeiId === ""
                        ).length;
                        // 匹配成功的 单位工程长度
                        let _successLength = _allLength - _failedLength;

                        // 提示消息
                        let _msg = `拟导入的XML文件共 ${_allLength} 个单位工程，${_successLength} 个单位工程匹配成功；其中 ${_existLength} 个节点已有数据；${_failedLength} 个单位工程匹配失败，请手动处理。`;

                        this.$message({
                            showClose: true,
                            message: _msg,
                            type: "warning",
                            duration: 5000,
                        });

                        this.loading = false;
                        this.$set(this, "leftData", res.data.param1);
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            }
        },

        // 最后确认
        doSubmit() {
            let _exist = this.leftData.filter((x) => x.isData === "是");
            let _msg = `原项目结构有 ${_exist.length} 个单位工程节点已有数据。是否覆盖原有数据？`;
            return new Promise((resolve) => {
                if (_exist.length === 0) {
                    resolve(true);
                    return;
                }

                // 最后确认
                this.$confirm(_msg, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then((res) => {
                        resolve(true);
                    })
                    .catch((err) => {
                        resolve(false);
                    });
            });
        },
    },
    computed: {
        //下拉选择动态监听leftData,并判断是否可选不可选
        curUnitList() {
            let selectedData = this.leftData.filter((item) => item.danWeiId);
            let selectedDataId = selectedData.map((item) => {
                return item.danWeiId;
            });
            let newcurUnitList = this.unitList.map((item) => {
                if (selectedDataId.includes(item.id)) {
                    return { ...item, disabled: true };
                } else {
                    return { ...item, disabled: false };
                }
            });
            return newcurUnitList;
        },

        // 项目ID
        curProjectId() {
            return this.$route.query.projectId;
        },
    },
    watch: {},
};
</script>

<style lang="less" scoped>
.preview-layout {
    height: 540px;
    .preview-header {
        height: 30px;
        line-height: 30px;
        text-align: left;
        color: #333;
        font-weight: bold;
        // margin-top: -7px;
        text-shadow: 1px 1px #ccc;
    }

    .btn-header {
        padding-right: 85px;
        position: relative;

        & > span {
            position: absolute;
            right: 0;
        }
    }
}
</style>
